import { SxProps } from "@mui/material";
import type { ThemeV2 } from "../../../util/types";

export const textFielsStyle = (theme: ThemeV2): SxProps => ({
  "& .MuiOutlinedInput-root": {
    "& fieldset": {
      border: "none",
    },
  },
  "& .MuiInputBase-input": {
    textAlign: "start",
    fontSize: {
      sm: theme.tokens.typography.size.md,
      xs: theme.tokens.typography.size.xs,
    },
    color: theme.tokens.color.action.primary,
    width: { xs: 40, md: "100%" },
  },
});

export const inputPropsStyle = {
  "& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button": {
    display: "none",
  },
  "& input[type=number]": {
    MozAppearance: "textfield",
  },
};
